export var ConnectionState;
(function (ConnectionState) {
    /**
     * Ready to connect
     */
    ConnectionState[ConnectionState["INIT"] = 0] = "INIT";
    /**
     * trying to connect
     */
    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
    /**
     * connection is in active state
     */
    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
    /**
     * dis-connected, probably due to network issues
     * If resilient connection is available, connection can be retried
     */
    ConnectionState[ConnectionState["DISCONNECTED"] = 3] = "DISCONNECTED";
    /**
     * Trying to reconnect at the moment, in case of resilient connection.
     */
    ConnectionState[ConnectionState["RECONNECTING"] = 4] = "RECONNECTING";
    /**
     * If basic connection, disconnected and then marked failed
     * If resilient connection is available, re-connection was attempted, failed to do so
     */
    ConnectionState[ConnectionState["FAILED"] = 5] = "FAILED";
    /**
     * gracefully closed
     */
    ConnectionState[ConnectionState["CLOSED"] = 6] = "CLOSED";
})(ConnectionState || (ConnectionState = {}));
//# sourceMappingURL=connection-state.js.map